import ApiService from "./api.service";

export type SharedLoginPlatform = "ios" | "android" | "web";
export type SharedLoginRecaptchaMode = "score" | "challenge";
export type SharedLoginPreferredLanguage = "zhHK" | "en";

export interface SendOtpRequest {
  phoneNumber: string;
  recaptchaToken?: string;
  platform?: SharedLoginPlatform;
  recaptchaMode?: SharedLoginRecaptchaMode;
}

export interface SendOtpResponse {
  status: string;
}

export interface VerifyOtpRequest {
  phoneNumber: string;
  code: string;
}

export interface VerifyOtpResponse {
  verifiedPhoneToken: string;
  expiresIn: number;
}

export interface MintReturnContextRequest {
  verifiedPhoneToken: string;
  destination: string;
}

export interface MintReturnContextResponse {
  returnContextToken: string;
  expiresIn: number;
}

export interface ConsumeReturnContextRequest {
  returnContextToken: string;
}

export interface ConsumeReturnContextResponse {
  phoneNumber: string;
  destination: string;
}

export interface ProvisionAccountRequest {
  verifiedPhoneToken: string;
  signupOriginProduct?: string;
  tncAgreedVersion?: string;
  marketingConsent?: boolean;
  preferredLanguage?: SharedLoginPreferredLanguage;
}

export interface ProvisionAccountResponse {
  customToken: string;
}

export class SharedLoginService extends ApiService {
  constructor() {
    super(process.env.REACT_APP_api_endpoint!);
  }

  sendOtp(
    phoneNumber: string,
    recaptchaToken?: string,
    platform?: SharedLoginPlatform,
    recaptchaMode?: SharedLoginRecaptchaMode,
  ) {
    return this.post<SendOtpResponse>("/v2/shared-login/otp/send", {
      phoneNumber,
      recaptchaToken,
      platform,
      recaptchaMode,
    });
  }

  verifyOtp(phoneNumber: string, code: string) {
    return this.post<VerifyOtpResponse>("/v2/shared-login/otp/verify", { phoneNumber, code });
  }

  mintReturnContext(verifiedPhoneToken: string, destination: string) {
    return this.post<MintReturnContextResponse>("/v2/shared-login/return-context", {
      verifiedPhoneToken,
      destination,
    });
  }

  consumeReturnContext(returnContextToken: string) {
    return this.post<ConsumeReturnContextResponse>("/v2/shared-login/return-context/consume", {
      returnContextToken,
    });
  }

  provisionAccount(
    verifiedPhoneToken: string,
    signupOriginProduct?: string,
    marketingConsent?: boolean,
    preferredLanguage?: SharedLoginPreferredLanguage,
  ) {
    return this.post<ProvisionAccountResponse>("/v2/shared-login/account", {
      verifiedPhoneToken,
      signupOriginProduct,
      marketingConsent,
      preferredLanguage,
    });
  }
}
